import { defineStore } from "pinia";
import { ref } from "vue";

import { useAuthorisationStore } from "@/modules/authorisation/authorisationStore";

export const useImpersonateStore = defineStore(
  "impersonate",
  () => {
    const impersonateId = ref<string>();
    const authorisationStore = useAuthorisationStore();

    async function setImpersonateId(id: string) {
      impersonateId.value = id;
      await authorisationStore.fetchProfileInformation(true);
    }

    return {
      impersonateId,
      setImpersonateId,
      $reset: () => {
        impersonateId.value = undefined;
      }
    };
  },
  { persist: true }
);
